import { Component, Input } from '@angular/core';

import { animate, style, transition, trigger } from '@angular/animations';
import { AbstractPageForm } from '../../pages/page-form.abstract';
import { LayeredPurchasingTopBannerType } from '../top-banner-type/layered-purchasing-top-banner-type/layered-purchasing-top-banner-type';
import { AbstractTopBannerType } from '../top-banner-type/top-banner-type.abstract';

@Component({
	selector: 'pk-broker-top-large-banner-alert',
	templateUrl: './top-large-banner-alert.component.html',
	styleUrl: './top-large-banner-alert.component.scss',
	animations: [
		trigger('activeInactiveFade', [
			transition(':enter', [style({ opacity: 0 }), animate('0.7s ease-in', style({ opacity: 1 }))]),
			transition(':leave', [animate('0.7s ease-out', style({ opacity: 0, visibility: 'hidden' }))]),
		]),
	],
	standalone: false,
})
export class TopLargeBannerAlertComponent extends AbstractPageForm {
	@Input() bannerTypes: AbstractTopBannerType[];
	@Input() interval = 30;

	public activeIndex = 0;

	constructor() {
		super();
	}

	public async loadPageData() {
		this.bannerTypes = this.bannerTypes.filter(b => this.environment.name !== 'demo' || b instanceof LayeredPurchasingTopBannerType);
	}

	public async onFormLoaded() {
		if (this.bannerTypes?.length > 1) {
			setInterval(() => {
				this.activeIndex = this.activeIndex === 0 ? 1 : 0;
			}, this.interval * 1000);
		}
	}
}
